import axios, { AxiosRequestConfig } from "axios";
import {
  Checklist,
  ChecklistAnswerFormData,
  ChecklistFormData,
  ChecklistGroupFormData,
  ChecklistQuestionFormData,
  GrupoPergunta,
  Pergunta,
  Resposta,
  UpdateChecklist,
  UpdateChecklistGrupoPergunta,
  UpdatePergunta,
  buscaChecklist,
} from "../types/checklistData";

export const getChecklist = async (
  token: string
): Promise<buscaChecklist[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar checklists:", error);
    throw error;
  }
};

export const getChecklistById = async (token: string, id: string): Promise<Checklist> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar checklist:", error);
    throw error;
  }
};

export const getGrupoById = async (token: string, id: string): Promise<GrupoPergunta> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistgrupo/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar grupo de perguntas:", error);
    throw error;
  }
};

export const getPerguntaById = async (token: string, id: string): Promise<Pergunta> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistpergunta/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar perguntas:", error);
    throw error;
  }
};

export const getRespostaById = async (token: string, id: string): Promise<Resposta> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistresposta/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar respostas:", error);
    throw error;
  }
};

export const createChecklist = async (
  token: string,
  checklistData: ChecklistFormData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist`;
    const response = await axios.post(url, checklistData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar checklist:", error);
    throw error;
  }
};

export const createChecklistGrupo = async (
  token: string,
  checklistGroupData: ChecklistGroupFormData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistgrupo`;
    const response = await axios.post(url, checklistGroupData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar grupo de perguntas do checklist:", error);
    throw error;
  }
};

export const createChecklistPergunta = async (
  token: string,
  checklistQuestionData: ChecklistQuestionFormData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistpergunta`;
    const response = await axios.post(url, checklistQuestionData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar pergunta ao checklist:", error);
    throw error;
  }
};

export const createChecklistResposta = async (
  token: string,
  checklistAnswerData: ChecklistAnswerFormData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistresposta`;
    const response = await axios.post(url, checklistAnswerData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar resposta ao checklist:", error);
    throw error;
  }
};

export const updateChecklist = async (
  token: string,
  id: string,
  checklistData: UpdateChecklist
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist/${id}`;
    const response = await axios.put(url, checklistData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar checklist:", error);
    throw error;
  }
};

export const updateChecklistGrupoPergunta = async (
  token: string,
  id: string,
  checklistGrupoPerguntaData: UpdateChecklistGrupoPergunta
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistgrupo/${id}`;
    const response = await axios.put(url, checklistGrupoPerguntaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar grupo de pergunta do checklist:", error);
    throw error;
  }
};

export const updatePergunta = async (
  token: string,
  id: string,
  perguntaData: UpdatePergunta
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklistpergunta/${id}`;
    const response = await axios.put(url, perguntaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar pergunta do checklist:", error);
    throw error;
  }
};

export const deleteChecklist = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir checklist:", error);
    throw error;
  }
};
